import { useQueryClient } from "@tanstack/react-query";

import { playbooksQueryKeys } from "../queries/queryKeyFactory";

import { usePlaybookToasts } from "./usePlaybookToasts";

/** Refetches the playbooks list so cadence names resolve again, and confirms the reconnect to the user. */
export const usePlaybooksSalesloftReconnectHandler = () => {
    const queryClient = useQueryClient();
    const { showSuccess } = usePlaybookToasts();

    return () => {
        void queryClient.invalidateQueries({ queryKey: playbooksQueryKeys.all(), exact: true });
        showSuccess("si.salesloft.reconnect-panel.success-toast");
    };
};
